<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'SettingDrawer',
})
</script>
<template>
    <div>
        <a-drawer :bodyStyle="{ padding: 0 }" width="1200" placement="right" :maskStyle="{ background: '#0000001a' }"
            @close="onClose" @afterOpenChange="afterOpenChange" :closable="false" :open="$store.state.showInform">
            <div class="inform-drawer">
                <div class="drawer-left">
                    <div class="title">
                        消息中心
                    </div>
                    <a-spin :spinning="state.loading">
                        <div class="menus">
                            <div class="menus-item"
                                :style="state.curentCat?.id == item.id ? { background: '#ebecf0' } : {}"
                                @click="selectMenus(item)" v-for="(item, index) in state.menusList" :key="index">
                                <div>
                                    <MailOutlined style="font-size: 16px; margin-right: 5px"
                                        v-if="item.cat_name == '站内信'" />
                                    <QuestionCircleOutlined style="font-size: 16px; margin-right: 5px"
                                        v-else-if="item.cat_name == '常见问题'" />
                                    <CloudDownloadOutlined style="font-size: 16px; margin-right: 5px"
                                        v-else-if="item.cat_name == '文件下载'" />
                                    <ReadOutlined style="font-size: 16px; margin-right: 5px"
                                        v-else-if="item.cat_name == '新闻中心'" />
                                    <BellOutlined v-else style="font-size: 16px; margin-right: 5px" />
                                    {{ item.cat_name }}
                                </div>
                                <a-badge color="#1677ff" :count="item.unread_num"> </a-badge>
                            </div>
                        </div>
                    </a-spin>
                </div>
                <div class="drawer-right">
                    <template v-if="state.curentCat">
                        <div class="title">
                            <HomeOutlined style="margin-right: 10px; cursor: pointer" @click="backList" />{{
                                state.curentCat.cat_name }}
                            <span v-if="state.showZw" style="margin-left: 10px;">
                                <RightOutlined /> 正文
                            </span>
                            <!-- 返回列表按钮 -->
                            <span v-if="state.showZw" class="back-to-list" @click="handleBackToList">
                                <RollbackOutlined /> 返回列表
                            </span>
                        </div>
                        <Inform :catid="state.curentCat.id" ref="childRef" @showzw="handleShowZw"
                            @backToList="handleBackToList"></Inform>
                    </template>
                </div>
            </div>
            <template #handle>
                <div class="inform-drawer-index-handle" v-if="$store.state.showInform" @click="onClose">
                    <CloseOutlined style="color: #fff" />
                </div>
            </template>
        </a-drawer>
    </div>
</template>

<script lang="ts" setup name="SettingDrawer">
import { BellOutlined } from '@ant-design/icons-vue'
import { CloseOutlined, QuestionCircleOutlined, HomeOutlined, MailOutlined, CloudDownloadOutlined, ReadOutlined, RightOutlined, RollbackOutlined } from '@ant-design/icons-vue'
import Inform from './components/inform.vue'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
import { ref, reactive } from 'vue'
import baseService from '@/utils/http/axios'
const $store = useStore()
const childRef = ref()
interface state {
    loading: boolean
    menusList: any[]
    curentCat: any
    showZw: boolean
}
const state = reactive<state>({
    loading: false,
    menusList: [],
    curentCat: null,
    showZw: false
})

const afterOpenChange = (open) => {
    if (open) {
        //打开后，加载页面内容
        state.loading = true
        let requestParam = {
            url: '/admin/v1/news/headCatList',
            method: 'post',
            data: {}
        }
        baseService(requestParam)
            .then((res: any) => {
                state.menusList = res.data
                if (state.menusList && state.menusList.length > 0) {
                    selectMenus(state.menusList[0])
                }
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败,请联系管理员')
                }
            })
            .finally(() => {
                state.loading = false
            })
    }
}
const onClose = () => {
    $store.commit('SET_SHOW_INFORM', false)
}

const selectMenus = (item) => {
    state.curentCat = item
    state.showZw = false
    // 重置子组件状态
    if (childRef.value) {
        childRef.value.resetList()
    }
}

const backList = () => {
    if (childRef.value) {
        childRef.value.onOk()
    }
    state.showZw = false
}

// 处理显示正文
const handleShowZw = () => {
    state.showZw = true
}

// 处理返回列表
const handleBackToList = () => {
    state.showZw = false
    if (childRef.value) {
        childRef.value.resetList()
    }
}
</script>

<style lang="less" scoped>
@import './index.less';

.back-to-list {
    margin-left: 20px;
    color: #1677ff;
    cursor: pointer;
    font-size: 14px;
    padding: 4px 12px;
    border-radius: 4px;
    transition: all 0.3s;

    &:hover {
        background: #e6f4ff;
    }
}
</style>
